// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2ofTX","text":"Button_text__2w7SL","small":"Button_small__65U3L","round":"Button_round__3KZAa","icon":"Button_icon__POcUE"};